export function formatDateTimeUnit(unit: number) {
  return String(unit).padStart(2, '0');
}
